export const incomeQuestions: Record<string, any> = {
  EMPLOYEE_PERMANENT_no: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.EMPLOYEE_PERMANENT_no.annualIncome',
      explanationKey: 'applicationForm.INCOME.EMPLOYEE_PERMANENT_no.annualIncome.explanation',
    },
  },
  EMPLOYEE_PERMANENT_yes: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.EMPLOYEE_PERMANENT_yes.annualIncome',
      explanationKey: 'applicationForm.INCOME.EMPLOYEE_PERMANENT_yes.annualIncome.explanation',
    },
  },
  EMPLOYEE_CONTRACTOR: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.EMPLOYEE_CONTRACTOR.annualIncome',
      explanationKey: 'applicationForm.INCOME.EMPLOYEE_CONTRACTOR.annualIncome.explanation',
    },
    prevYearAnnualIncome: {
      labelKey: 'applicationForm.INCOME.EMPLOYEE_CONTRACTOR.prevYearAnnualIncome',
    },
  },
  SELF_EMPLOYED_LIMITED_COMPANY_GREATER: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_GREATER.annualIncome',
    },
    prevYearAnnualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_GREATER.prevYearAnnualIncome',
    },
    dividends: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_GREATER.dividends',
    },
    prevYearDividends: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_GREATER.prevYearDividends',
    },
  },
  SELF_EMPLOYED_LIMITED_COMPANY_BELOW: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.annualIncome',
      explanationKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.annualIncome.explanation',
    },
    prevYearAnnualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.prevYearAnnualIncome',
    },
    dividends: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.dividends',
    },
    prevYearDividends: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_LIMITED_COMPANY_BELOW.prevYearDividends',
    },
  },
  SELF_EMPLOYED_SOLE_TRADER: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_SOLE_TRADER.annualIncome',
    },
    prevYearAnnualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_SOLE_TRADER.prevYearAnnualIncome',
    },
  },
  SELF_EMPLOYED_PARTNERSHIP: {
    annualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_PARTNERSHIP.annualIncome',
    },
    prevYearAnnualIncome: {
      labelKey: 'applicationForm.INCOME.SELF_EMPLOYED_PARTNERSHIP.prevYearAnnualIncome',
    },
  },
};
